type AvatarTone = "brand" | "gray" | "warning" | "success" | "error" | "pink" | "blue";

const AVATAR_TONES: Record<AvatarTone, { bg: string; fg: string }> = {
  brand: { bg: "var(--color-brand-100)", fg: "var(--color-brand-700)" },
  gray: { bg: "var(--color-gray-200)", fg: "var(--color-gray-700)" },
  warning: { bg: "var(--color-warning-100)", fg: "var(--color-warning-700)" },
  success: { bg: "var(--color-success-100)", fg: "var(--color-success-700)" },
  error: { bg: "var(--color-error-100)", fg: "var(--color-error-700)" },
  pink: { bg: "rgb(252,231,246)", fg: "rgb(193,21,116)" },
  blue: { bg: "rgb(209,233,255)", fg: "rgb(23,92,211)" },
};

export function ScopeAvatar({
  initials,
  tone = "brand",
  size = 32,
  square = false,
}: {
  initials: string;
  tone?: AvatarTone;
  size?: number;
  square?: boolean;
}) {
  const colors = AVATAR_TONES[tone] ?? AVATAR_TONES.gray;
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: square ? Math.round(size * 0.25) : 9999,
        background: colors.bg,
        color: colors.fg,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: Math.round(size * 0.36),
        fontWeight: 600,
        flexShrink: 0,
        border: "1px solid rgba(0,0,0,0.06)",
        letterSpacing: "-0.01em",
      }}
    >
      {initials}
    </div>
  );
}
